module.exports = __webpack_public_path__ + "static/media/pest-control-icon.cb8326c5.svg";